<section class="content-section">
  <div class="section-header">
    <div>
      <h2>{{ 'ppwr.docProfiles.title' | transloco }}</h2>
      <p>{{ 'ppwr.docProfiles.description' | transloco }}</p>
    </div>
    <button mat-stroked-button color="primary" type="button" (click)="addProfile()">
      <mat-icon>add</mat-icon>{{ 'common.buttons.add' | transloco }}
    </button>
  </div>

  <div class="role-list">
    <div class="empty-state" *ngIf="docProfiles.length === 0">
      <mat-icon class="empty-state-icon">description</mat-icon>
      <div class="empty-state-title">{{ 'ppwr.docProfiles.emptyState.title' | transloco }}</div>
      <div class="empty-state-text">{{ 'ppwr.docProfiles.emptyState.text' | transloco }}</div>
    </div>
    <mat-expansion-panel
      *ngFor="let profile of docProfiles"
      class="doc-profile-item"
      [expanded]="isLinkManufacturerOpen(profile)"
      (opened)="openLinkManufacturer(profile)"
      (closed)="onLinkManufacturerClosed(profile)">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span class="doc-profile-name">
            <strong>{{ profile.profileName }}</strong>
          </span>
        </mat-panel-title>
        <mat-panel-description>
          <span>{{ 'ppwr.docProfiles.linkedManufacturers' | transloco: { count: linkedManufacturerCount(profile) } }}</span>
          <span class="item-actions" (click)="$event.stopPropagation()">
            <button mat-icon-button color="primary" type="button" [attr.aria-label]="'common.buttons.edit' | transloco" (click)="editProfile(profile)">
              <mat-icon>edit</mat-icon>
            </button>
            <button
              mat-icon-button
              color="warn"
              type="button"
              [attr.aria-label]="'ppwr.docProfiles.deleteAria' | transloco"
              (click)="confirmDeleteProfile(profile)">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </span>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <p class="empty-text" *ngIf="manufacturers.length === 0">
        {{ 'dataManagement.organizationSettings.emptyStates.manufacturers' | transloco }}
      </p>
      <mat-card *ngIf="manufacturers.length > 0" class="manufacturer-link-card" appearance="outlined">
        <div class="manufacturer-link-header">
          <h3>{{ 'ppwr.docProfiles.linkManufacturerHeading' | transloco }}</h3>
          <mat-form-field appearance="outline" class="manufacturer-search" subscriptSizing="dynamic">
            <mat-label>{{ 'ppwr.docProfiles.manufacturerSearchLabel' | transloco }}</mat-label>
            <input matInput [formControl]="manufacturerSearchControl" />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
        </div>

        <mat-checkbox
          class="select-all"
          [checked]="areAllManufacturersLinked(profile)"
          [indeterminate]="areSomeManufacturersLinked(profile)"
          (change)="toggleAllManufacturerLinks(profile)">
          {{ 'common.buttons.selectAll' | transloco }}
        </mat-checkbox>
        <div class="manufacturer-checkbox-list">
          <mat-checkbox
            *ngFor="let manufacturer of filteredManufacturers()"
            [checked]="isManufacturerLinked(profile, manufacturer)"
            (change)="toggleManufacturerLink(profile, manufacturer)">
            {{ manufacturer.companyName }}
          </mat-checkbox>
        </div>
      </mat-card>

      <div class="link-manufacturer-actions">
        <button mat-button type="button" (click)="cancelLinkManufacturer()">
          {{ 'common.buttons.cancel' | transloco }}
        </button>
        <button mat-raised-button color="primary" type="button" [disabled]="!hasManufacturerLinkChanges()" (click)="saveManufacturerLinks()">
          {{ 'common.buttons.save' | transloco }}
        </button>
      </div>
    </mat-expansion-panel>
  </div>
</section>
